module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "life"
    }
  }, [_c('h1', [_vm._v("Life")]), _vm._v(" "), _c('p', [_c('strong', [_c('em', [_vm._v("Life, intolerance, while time slips quickly by")])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_c('strong', [_c('em', [_vm._v("The frosted glass of fate.")])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_c('strong', [_c('em', [_vm._v("Sweet memories of incompatibility")])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_c('strong', [_c('em', [_vm._v("Change to despair and shadowed death.")])])]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_c('strong', [_c('em', [_vm._v("For what purpose do we live?")])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_c('strong', [_c('em', [_vm._v("Knowing of eternal beauty and splendour")])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_c('strong', [_c('em', [_vm._v("Waiting just around the corner.")])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_c('strong', [_c('em', [_vm._v("To this there can be no answering.")])])]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_c('strong', [_c('em', [_vm._v("One pattern, one path incomplete")])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_c('strong', [_c('em', [_vm._v("Desiring, love, lust demolished! Returned to dust.")])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_c('strong', [_c('em', [_vm._v("Now one and all to cry, repeat!")])])]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("RAS 1966–1968")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a817782","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch004.vue
// module id = 72
// module chunks = 0